import { render, staticRenderFns } from "./detail_company_page.vue?vue&type=template&id=6a6d84e5&scoped=true"
import script from "./detail_company_page.vue?vue&type=script&lang=js"
export * from "./detail_company_page.vue?vue&type=script&lang=js"
import style0 from "./detail_company_page.vue?vue&type=style&index=0&id=6a6d84e5&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6d84e5",
  null
  
)

export default component.exports